import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useT } from "@/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

/** Anulación con motivo (genera contraasiento) de un pago, anticipo, o movimiento/certificación de obra. */
export const VoidDialog = ({ open, onOpenChange, kind = "payment", id, invalidateKeys }) => {
  const { t } = useT();
  const qc = useQueryClient();
  const [motivo, setMotivo] = useState("");

  const ENDPOINTS = {
    payment: "payments", advance: "advances", purchase: "purchases",
    project_movement: "projects/movements", project_certification: "projects/certifications",
  };

  const mutation = useMutation({
    mutationFn: () => api.post(`/${ENDPOINTS[kind] || "payments"}/${id}/void`, { motivo }),
    onSuccess: () => {
      toast.success(t("finance.payments.voided"));
      (invalidateKeys || [["payments"], ["advances"], ["sub-statement"]]).forEach((k) => qc.invalidateQueries({ queryKey: k }));
      setMotivo("");
      onOpenChange(false);
    },
    onError: (e) => toast.error(e?.response?.data?.detail || "Error"),
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="void-dialog" className="max-w-md rounded-[10px]">
        <DialogHeader>
          <DialogTitle>{t("finance.payments.void_title")}</DialogTitle>
          <DialogDescription>{t("finance.payments.void_desc")}</DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="void-reason-input"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          placeholder={t("finance.payments.void_reason_ph")}
          rows={3}
        />
        <DialogFooter>
          <Button
            data-testid="void-confirm-button"
            variant="destructive"
            disabled={motivo.trim().length < 5 || mutation.isPending}
            onClick={() => mutation.mutate()}
          >
            {t("finance.payments.void")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
